import router from '@/router';

export const LOGIN_PAGE_NAME = 'auth';
export const LOGIN_INTERNAL_PAGE_NAME = 'auth:page';
export const LOGIN_PAGE_ID_LOGIN = 'login';
export const LOGIN_PAGE_ID_CHANGE_PASSWORD = 'change-password';
export const LOGIN_PAGE_ID_GOOGLE_LOGIN = 'google-login';
export const LOGIN_PAGE_ID_FORGOT_PASSWORD = 'forgot-password';
export const LOGIN_PAGE_ID_RECOVER_PASSWORD = 'recover-password';
export const LOGIN_PAGE_ID_SECOND_FACTOR = 'second-factor';
export const LOGIN_PAGE_ID_CONFIGURE_SECOND_FACTOR = 'configure-second-factor';

export const redirectToLoginPage = (id: string, query: { [k: string]: any } = {}) => {
  const redirectTo = router.currentRoute.query.redirectTo;
  if (redirectTo) {
    query.redirectTo = redirectTo;
  }

  router.push({
    name: LOGIN_PAGE_NAME,
    params: {
      page: id,
    },
    query,
  });
};
